var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _linearGradient31, _linearGradient32, _linearGradient33, _linearGradient34, _linearGradient35, _linearGradient36, _linearGradient37, _linearGradient38, _linearGradient39, _linearGradient40, _linearGradient41, _linearGradient42, _linearGradient43, _linearGradient44, _linearGradient45, _linearGradient46, _linearGradient47, _linearGradient48, _linearGradient49, _linearGradient50, _linearGradient51, _linearGradient52, _linearGradient53, _linearGradient54, _linearGradient55, _linearGradient56, _linearGradient57, _linearGradient58, _linearGradient59, _linearGradient60, _linearGradient61, _linearGradient62, _linearGradient63, _linearGradient64, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconStayHome(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    enableBackground: "new 0 0 510 510",
    height: 512,
    viewBox: "0 0 510 510",
    width: 512,
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#fe99a0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fd4755"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_1_",
    gradientUnits: "userSpaceOnUse",
    x1: 34.099,
    x2: 64.068,
    xlinkHref: "#lg1",
    y1: 372.581,
    y2: 402.55
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_2_",
    gradientUnits: "userSpaceOnUse",
    x1: 448.879,
    x2: 476.541,
    xlinkHref: "#lg1",
    y1: 409.387,
    y2: 437.049
  })), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#eef5f6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cbe5e8"
  }))), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_3_",
    gradientUnits: "userSpaceOnUse",
    x1: 36.678,
    x2: 93.633,
    xlinkHref: "#lg2",
    y1: 91.935,
    y2: 167.231
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#cbe5e8",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7ca1b1"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_4_",
    gradientUnits: "userSpaceOnUse",
    x1: 86.544,
    x2: 86.544,
    xlinkHref: "#lg3",
    y1: 132.399,
    y2: 63.687
  })), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#60b7ff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0268b4"
  }))), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_5_",
    gradientUnits: "userSpaceOnUse",
    x1: 75.46,
    x2: 100.988,
    xlinkHref: "#lg4",
    y1: 36.243,
    y2: 100.063
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_6_",
    gradientUnits: "userSpaceOnUse",
    x1: 153.013,
    x2: 443.721,
    xlinkHref: "#lg2",
    y1: 243.933,
    y2: 534.64
  })), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_7_",
    gradientUnits: "userSpaceOnUse",
    x1: 336.796,
    x2: 149.305,
    xlinkHref: "#lg3",
    y1: 448.462,
    y2: 71.623
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_8_",
    gradientUnits: "userSpaceOnUse",
    x1: 443.558,
    x2: 281.558,
    xlinkHref: "#lg3",
    y1: 470.469,
    y2: 385.135
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_9_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg3",
    y1: 459.579,
    y2: 518.782
  })), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_10_",
    gradientUnits: "userSpaceOnUse",
    x1: 126.04,
    x2: 322.933,
    xlinkHref: "#lg4",
    y1: 116.661,
    y2: 313.555
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_11_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg4",
    y1: 347.271,
    y2: -1.581
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#537983"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_12_",
    gradientUnits: "userSpaceOnUse",
    x1: 141.367,
    x2: 255.389,
    xlinkHref: "#lg5",
    y1: 259.384,
    y2: 373.407
  })), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg6"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffe177"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fe9738"
  }))), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_13_",
    gradientUnits: "userSpaceOnUse",
    x1: 231.674,
    x2: 269.224,
    xlinkHref: "#lg6",
    y1: 428.596,
    y2: 548.288
  })), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg7"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffdcbd"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ffa9b1"
  }))), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_14_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg7",
    y1: 453.53,
    y2: 447.479
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_15_",
    gradientUnits: "userSpaceOnUse",
    x1: 230.361,
    x2: 210.569,
    xlinkHref: "#lg6",
    y1: 425.33,
    y2: 456.997
  })), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_16_",
    gradientUnits: "userSpaceOnUse",
    x1: 281.717,
    x2: 298.63,
    xlinkHref: "#lg6",
    y1: 428.679,
    y2: 455.668
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_17_",
    gradientUnits: "userSpaceOnUse",
    x1: 149.92,
    x2: 175.371,
    xlinkHref: "#lg7",
    y1: 311.697,
    y2: 337.148
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_18_",
    gradientUnits: "userSpaceOnUse",
    x1: 327.885,
    x2: 363.499,
    xlinkHref: "#lg7",
    y1: 306.863,
    y2: 342.476
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_19_",
    gradientUnits: "userSpaceOnUse",
    x1: 163.471,
    x2: 346.529,
    xlinkHref: "#lg7",
    y1: 326.942,
    y2: 326.942
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_20_",
    gradientUnits: "userSpaceOnUse",
    x1: 220.217,
    x2: 289.783,
    xlinkHref: "#lg1",
    y1: 394.611,
    y2: 394.611
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_21_",
    gradientUnits: "userSpaceOnUse",
    x1: 202.586,
    x2: 232.313,
    xlinkHref: "#lg5",
    y1: 321.466,
    y2: 321.466
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_22_",
    gradientUnits: "userSpaceOnUse",
    x1: 277.687,
    x2: 307.414,
    xlinkHref: "#lg5",
    y1: 321.466,
    y2: 321.466
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_23_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 333.306,
    y2: 359.926
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffa9b1",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9972,
    stopColor: "#ffa78f"
  }))), _linearGradient31 || (_linearGradient31 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_24_",
    gradientUnits: "userSpaceOnUse",
    x1: 188.271,
    x2: 302.294,
    xlinkHref: "#lg5",
    y1: 212.479,
    y2: 326.502
  })), _linearGradient32 || (_linearGradient32 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_25_",
    gradientUnits: "userSpaceOnUse",
    x1: 170.332,
    x2: 170.332,
    xlinkHref: "#lg2",
    y1: 328,
    y2: 357.5
  })), _linearGradient33 || (_linearGradient33 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_26_",
    gradientTransform: "matrix(-1 0 0 1 -1445.417 0)",
    gradientUnits: "userSpaceOnUse",
    x1: -1785.085,
    x2: -1785.085,
    xlinkHref: "#lg2",
    y1: 328,
    y2: 357.5
  })), _linearGradient34 || (_linearGradient34 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_27_",
    gradientUnits: "userSpaceOnUse",
    x1: 246.437,
    x2: 269.206,
    y1: 363.246,
    y2: 404.096
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#9ae1d3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#80d1c1"
  }))), _linearGradient35 || (_linearGradient35 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_28_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 369.677,
    y2: 456.194
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#c1e9af"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4fc123"
  }))), _linearGradient36 || (_linearGradient36 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_29_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    xlinkHref: "#lg2",
    y1: 344.186,
    y2: 360.209
  })), _linearGradient37 || (_linearGradient37 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_30_",
    gradientUnits: "userSpaceOnUse",
    x1: 255,
    x2: 255,
    y1: 437.523,
    y2: 454.538
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4fc123",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1348,
    stopColor: "#4bab2f",
    stopOpacity: 0.135
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.385,
    stopColor: "#468741",
    stopOpacity: 0.385
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6201,
    stopColor: "#426e4e",
    stopOpacity: 0.62
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8318,
    stopColor: "#3f5e56",
    stopOpacity: 0.832
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3e5959"
  }))), _linearGradient38 || (_linearGradient38 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_31_",
    gradientUnits: "userSpaceOnUse",
    x1: 418.988,
    x2: 434.533,
    xlinkHref: "#lg1",
    y1: 37.757,
    y2: 37.757
  })), _linearGradient39 || (_linearGradient39 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_32_",
    gradientUnits: "userSpaceOnUse",
    x1: 420.975,
    x2: 431.677,
    xlinkHref: "#lg1",
    y1: 9.743,
    y2: 20.445
  })), _linearGradient40 || (_linearGradient40 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_33_",
    gradientTransform: "matrix(1 0 0 -1 0 2893.906)",
    gradientUnits: "userSpaceOnUse",
    x1: 418.988,
    x2: 434.533,
    xlinkHref: "#lg1",
    y1: 2798.997,
    y2: 2798.997
  })), _linearGradient41 || (_linearGradient41 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_34_",
    gradientTransform: "matrix(1 0 0 -1 0 2893.906)",
    gradientUnits: "userSpaceOnUse",
    x1: 420.975,
    x2: 431.677,
    xlinkHref: "#lg1",
    y1: 2770.983,
    y2: 2781.685
  })), _linearGradient42 || (_linearGradient42 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_35_",
    gradientTransform: "matrix(0 1 -1 0 1042 1596)",
    gradientUnits: "userSpaceOnUse",
    x1: -1535.485,
    x2: -1519.94,
    xlinkHref: "#lg1",
    y1: 588.618,
    y2: 588.618
  })), _linearGradient43 || (_linearGradient43 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_36_",
    gradientTransform: "matrix(0 1 -1 0 1042 1596)",
    gradientUnits: "userSpaceOnUse",
    x1: -1533.499,
    x2: -1522.797,
    xlinkHref: "#lg1",
    y1: 560.604,
    y2: 571.306
  })), _linearGradient44 || (_linearGradient44 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_37_",
    gradientTransform: "matrix(0 1 1 0 -1851.906 1596)",
    gradientUnits: "userSpaceOnUse",
    x1: -1535.485,
    x2: -1519.94,
    xlinkHref: "#lg1",
    y1: 2248.137,
    y2: 2248.137
  })), _linearGradient45 || (_linearGradient45 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_38_",
    gradientTransform: "matrix(0 1 1 0 -1851.906 1596)",
    gradientUnits: "userSpaceOnUse",
    x1: -1533.499,
    x2: -1522.797,
    xlinkHref: "#lg1",
    y1: 2220.123,
    y2: 2230.825
  })), _linearGradient46 || (_linearGradient46 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_39_",
    gradientTransform: "matrix(.707 .707 -.707 .707 851.542 582.195)",
    gradientUnits: "userSpaceOnUse",
    x1: -672.335,
    x2: -656.79,
    xlinkHref: "#lg1",
    y1: -91.597,
    y2: -91.597
  })), _linearGradient47 || (_linearGradient47 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_40_",
    gradientTransform: "matrix(.707 .707 -.707 .707 851.542 582.195)",
    gradientUnits: "userSpaceOnUse",
    x1: -670.349,
    x2: -659.647,
    xlinkHref: "#lg1",
    y1: -119.611,
    y2: -108.909
  })), _linearGradient48 || (_linearGradient48 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_41_",
    gradientTransform: "matrix(.707 .707 .707 -.707 -1194.758 2628.496)",
    gradientUnits: "userSpaceOnUse",
    x1: -672.335,
    x2: -656.79,
    xlinkHref: "#lg1",
    y1: 2928.351,
    y2: 2928.351
  })), _linearGradient49 || (_linearGradient49 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_42_",
    gradientTransform: "matrix(.707 .707 .707 -.707 -1194.758 2628.496)",
    gradientUnits: "userSpaceOnUse",
    x1: -670.349,
    x2: -659.647,
    xlinkHref: "#lg1",
    y1: 2900.338,
    y2: 2911.04
  })), _linearGradient50 || (_linearGradient50 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_43_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 459.805 2447.543)",
    gradientUnits: "userSpaceOnUse",
    x1: -1664.839,
    x2: -1649.294,
    xlinkHref: "#lg1",
    y1: 1679.941,
    y2: 1679.941
  })), _linearGradient51 || (_linearGradient51 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_44_",
    gradientTransform: "matrix(-.707 .707 -.707 -.707 459.805 2447.543)",
    gradientUnits: "userSpaceOnUse",
    x1: -1662.853,
    x2: -1652.151,
    xlinkHref: "#lg1",
    y1: 1651.927,
    y2: 1662.629
  })), _linearGradient52 || (_linearGradient52 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_45_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -1586.496 401.242)",
    gradientUnits: "userSpaceOnUse",
    x1: -1664.839,
    x2: -1649.294,
    xlinkHref: "#lg1",
    y1: 1156.813,
    y2: 1156.813
  })), _linearGradient53 || (_linearGradient53 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_46_",
    gradientTransform: "matrix(-.707 .707 .707 .707 -1586.496 401.242)",
    gradientUnits: "userSpaceOnUse",
    x1: -1662.853,
    x2: -1652.151,
    xlinkHref: "#lg1",
    y1: 1128.799,
    y2: 1139.501
  })), _linearGradient54 || (_linearGradient54 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_47_",
    gradientUnits: "userSpaceOnUse",
    x1: 402.555,
    x2: 449.216,
    xlinkHref: "#lg1",
    y1: 44.082,
    y2: 90.742
  })), _linearGradient55 || (_linearGradient55 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_48_",
    gradientUnits: "userSpaceOnUse",
    x1: 458.52,
    x2: 486.032,
    xlinkHref: "#lg1",
    y1: 139.789,
    y2: 167.3
  })), _linearGradient56 || (_linearGradient56 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_49_",
    gradientUnits: "userSpaceOnUse",
    x1: 107.025,
    x2: 134.537,
    xlinkHref: "#lg1",
    y1: 6.38,
    y2: 33.892
  })), _linearGradient57 || (_linearGradient57 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_50_",
    gradientUnits: "userSpaceOnUse",
    x1: 452.148,
    x2: 469.43,
    xlinkHref: "#lg1",
    y1: 188.916,
    y2: 206.198
  })), _linearGradient58 || (_linearGradient58 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_51_",
    gradientUnits: "userSpaceOnUse",
    x1: 152.759,
    x2: 170.041,
    xlinkHref: "#lg1",
    y1: 29.759,
    y2: 47.041
  })), _linearGradient59 || (_linearGradient59 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_52_",
    gradientUnits: "userSpaceOnUse",
    x1: 470.649,
    x2: 487.931,
    xlinkHref: "#lg1",
    y1: 369.026,
    y2: 386.309
  })), _linearGradient60 || (_linearGradient60 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_53_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.868,
    x2: 40.151,
    xlinkHref: "#lg1",
    y1: 311.092,
    y2: 328.374
  })), _linearGradient61 || (_linearGradient61 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_54_",
    gradientUnits: "userSpaceOnUse",
    x1: 22.868,
    x2: 40.151,
    xlinkHref: "#lg1",
    y1: 439.759,
    y2: 457.041
  })), _linearGradient62 || (_linearGradient62 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_55_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.563,
    x2: 489.17,
    xlinkHref: "#lg1",
    y1: 312.942,
    y2: 323.549
  })), _linearGradient63 || (_linearGradient63 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_56_",
    gradientUnits: "userSpaceOnUse",
    x1: 478.563,
    x2: 489.17,
    xlinkHref: "#lg1",
    y1: 460.942,
    y2: 471.549
  })), _linearGradient64 || (_linearGradient64 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "SVGID_57_",
    gradientUnits: "userSpaceOnUse",
    x1: 54.259,
    x2: 71.541,
    xlinkHref: "#lg1",
    y1: 22.259,
    y2: 39.541
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    cx: 48.391,
    cy: 386.872,
    fill: "url(#SVGID_1_)",
    r: 21.242
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462.07,
    cy: 422.578,
    fill: "url(#SVGID_2_)",
    r: 19.607
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m46.195 65.535h80.697v184.649h-80.697z",
    fill: "url(#SVGID_3_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.195 82.514 80.698 76.143v-93.122h-80.698z",
    fill: "url(#SVGID_4_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m128.047 81.715h-83.005c-5.77 0-10.447-4.677-10.447-10.447v-14.63c0-5.77 4.677-10.447 10.447-10.447h83.005c5.77 0 10.447 4.677 10.447 10.447v14.63c-.001 5.77-4.678 10.447-10.447 10.447z",
    fill: "url(#SVGID_5_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.517 510h-351.034c-18.384 0-33.288-14.062-33.288-31.409v-208.42l180.397-249.158c14.002-19.339 42.815-19.339 56.817 0l180.396 249.158v208.42c0 17.347-14.904 31.409-33.288 31.409z",
    fill: "url(#SVGID_6_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m226.592 21.013-180.397 249.158v27.778l224.733 212.051h159.589c18.384 0 33.288-14.062 33.288-31.409v-208.42l-180.397-249.158c-14.002-19.339-42.814-19.339-56.816 0z",
    fill: "url(#SVGID_7_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m430.517 510c18.384 0 33.288-14.063 33.288-31.409v-128.089l-126.781-126.78c-19.585-21.625-47.884-35.21-79.357-35.21-59.115 0-107.038 47.922-107.038 107.038v179.736c-4.771 10.65-7.566 22.376-7.92 34.715h287.808z",
    fill: "url(#SVGID_8_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m46.195 410.085v68.505c0 17.347 14.903 31.409 33.288 31.409h351.034c18.384 0 33.288-14.062 33.288-31.409v-68.505z",
    fill: "url(#SVGID_9_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m268.217 102.043 131.899 188.57c2.921 4.176 7.87 6.689 13.173 6.689h62.042c12.573 0 20.098-13.194 13.173-23.096l-167.896-240.032c-31.871-45.565-99.344-45.565-131.215 0l-167.896 240.032c-6.926 9.901.6 23.096 13.173 23.096h62.042c5.303 0 10.251-2.513 13.173-6.689l131.899-188.57c6.42-9.179 20.012-9.179 26.433 0z",
    fill: "url(#SVGID_10_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m109.884 290.613 131.899-188.57c6.259-8.949 20.174-8.949 26.434 0l131.899 188.57c2.921 4.176 7.87 6.689 13.173 6.689h48.428l-169.849-242.825c-17.46-24.962-56.276-24.962-73.736 0l-169.849 242.825h48.428c5.304 0 10.252-2.513 13.173-6.689z",
    fill: "url(#SVGID_11_)"
  }))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m362.038 497.488h-214.076v-204.605c0-59.115 47.922-107.038 107.038-107.038 59.115 0 107.038 47.922 107.038 107.038z",
    fill: "url(#SVGID_12_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m140.002 510c0-50.55 40.979-91.529 91.529-91.529h46.938c50.55 0 91.529 40.979 91.529 91.529z",
    fill: "url(#SVGID_13_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255.746 446.487c18.752 0 29.51-12.653-1.176-12.653s-17.929 12.653 1.176 12.653z",
    fill: "url(#SVGID_14_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m200.662 420.937s-15.834 7.917-10.796 14.394c3.706 4.764 22.596 23.156 32.329 32.551 3.227 3.115 8.347 3.062 11.518-.11l21.287-21.285z",
    fill: "url(#SVGID_15_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m309.338 420.937s15.834 7.917 10.796 14.394c-3.706 4.764-22.596 23.156-32.329 32.551-3.227 3.115-8.347 3.062-11.518-.11l-21.287-21.285z",
    fill: "url(#SVGID_16_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m140.609 325.377c0-14.964 10.387-27.502 24.345-30.797 3.731-.881 7.297 2.004 7.297 5.838v49.918c0 3.833-3.566 6.719-7.297 5.838-13.958-3.294-24.345-15.832-24.345-30.797z",
    fill: "url(#SVGID_17_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m369.391 325.377c0-14.964-10.387-27.502-24.345-30.797-3.731-.881-7.297 2.004-7.297 5.838v49.918c0 3.833 3.567 6.719 7.297 5.838 13.958-3.294 24.345-15.832 24.345-30.797z",
    fill: "url(#SVGID_18_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m255 441.94c-50.55 0-91.529-40.979-91.529-91.529v-46.938c0-50.55 40.979-91.529 91.529-91.529 50.55 0 91.529 40.979 91.529 91.529v46.938c0 50.55-40.979 91.529-91.529 91.529z",
    fill: "url(#SVGID_19_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m255 412.388c-16.814 0-30.902-11.671-34.604-27.354-.99-4.192 2.252-8.199 6.56-8.199h56.089c4.307 0 7.549 4.007 6.56 8.199-3.703 15.682-17.791 27.354-34.605 27.354z",
    fill: "url(#SVGID_20_)"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m217.45 340.141c-8.209 0-14.864-6.655-14.864-14.864v-7.622c0-8.209 6.655-14.864 14.864-14.864 8.209 0 14.864 6.655 14.864 14.864v7.622c-.001 8.209-6.655 14.864-14.864 14.864z",
    fill: "url(#SVGID_21_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m292.55 340.141c-8.209 0-14.864-6.655-14.864-14.864v-7.622c0-8.209 6.655-14.864 14.864-14.864 8.209 0 14.864 6.655 14.864 14.864v7.622c0 8.209-6.655 14.864-14.864 14.864z",
    fill: "url(#SVGID_22_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m260.056 361.754h-10.113c-8.428 0-14.809-7.616-13.333-15.914l5.797-32.589h25.184l5.797 32.589c1.477 8.298-4.904 15.914-13.332 15.914z",
    fill: "url(#SVGID_23_)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "m353.906 297.981c-3.71.332-8.227.647-13.117.943-20.026 1.212-36.946-14.686-36.946-34.749-22.329 24.668-54.392 38.201-87.647 37.113-22.024-.72-43.693-1.849-60.113-3.333 1.552-43.844 31.646-80.413 72.254-91.755 8.48-2.381 17.415-3.638 26.67-3.638 9.256 0 18.191 1.257 26.671 3.638 16.612 4.628 31.486 13.509 43.336 25.36 17.121 17.146 27.982 40.5 28.892 66.421z",
    fill: "url(#SVGID_24_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m165.658 374.75c-1.168 0-2.323-.534-3.092-1.555-1.319-1.748-1.004-4.26.702-5.61l13.793-10.92-21.793-57.258c-.783-2.058.21-4.377 2.219-5.18 2.006-.805 4.272.214 5.055 2.273l22.855 60.046c.63 1.653.121 3.533-1.25 4.618l-16.104 12.75c-.711.564-1.551.836-2.385.836z",
    fill: "url(#SVGID_25_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m344.342 374.75c1.168 0 2.323-.534 3.092-1.555 1.319-1.748 1.004-4.26-.702-5.61l-13.793-10.92 21.793-57.258c.783-2.058-.21-4.377-2.219-5.18-2.006-.805-4.272.214-5.055 2.273l-22.855 60.046c-.63 1.653-.121 3.533 1.25 4.618l16.104 12.75c.711.564 1.551.836 2.385.836z",
    fill: "url(#SVGID_26_)"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m338.663 367.978c.362-7.782-4.278-14.097-12.399-16.115-46.162-11.473-96.368-11.472-142.529 0-8.121 2.018-12.76 8.333-12.399 16.115 1.342 28.891 11.008 51.264 26.218 68.77 3.008 3.462 8.266 5.997 13.906 6.76 29.318 3.971 57.76 3.971 87.079 0 5.64-.764 10.898-3.298 13.906-6.76 15.21-17.506 24.876-39.879 26.218-68.77z",
    fill: "url(#SVGID_27_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m338.663 367.978c.362-7.782-4.278-14.097-12.399-16.115-46.162-11.473-96.368-11.472-142.529 0-8.121 2.018-12.76 8.333-12.399 16.115 1.342 28.891 11.008 51.264 26.218 68.77 3.008 3.462 8.266 5.997 13.906 6.76 29.318 3.971 57.76 3.971 87.079 0 5.64-.764 10.898-3.298 13.906-6.76 15.21-17.506 24.876-39.879 26.218-68.77z",
    fill: "url(#SVGID_28_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m175.506 368.888c51.333-11.939 107.653-11.94 158.987 0 1.232.286 2.39.66 3.47 1.113.952.399 2.445-.652 2.507-1.775.001-.01.001-.02.002-.03.435-7.949-4.258-14.408-12.551-16.474-47.206-11.76-98.637-11.76-145.842 0-8.293 2.066-12.986 8.525-12.551 16.474.001.01.001.02.002.03.062 1.124 1.555 2.174 2.507 1.775 1.079-.453 2.238-.827 3.469-1.113z",
    fill: "url(#SVGID_29_)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m192.083 429.906c1.729 2.351 3.551 4.631 5.471 6.842 3.008 3.462 8.266 5.996 13.906 6.76 29.318 3.971 57.76 3.971 87.079 0 5.64-.764 10.898-3.298 13.906-6.76 1.921-2.211 3.743-4.491 5.471-6.842z",
    fill: "url(#SVGID_30_)"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m424.806 57.576c-2.41 0-4.363-1.954-4.363-4.363v-30.91c0-2.41 1.954-4.363 4.363-4.363 2.41 0 4.363 1.954 4.363 4.363v30.91c.001 2.409-1.953 4.363-4.363 4.363z",
    fill: "url(#SVGID_31_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.806,
    cy: 13.575,
    fill: "url(#SVGID_32_)",
    r: 13.575
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m424.806 75.091c-2.41 0-4.363 1.954-4.363 4.363v30.91c0 2.41 1.954 4.363 4.363 4.363 2.41 0 4.363-1.954 4.363-4.363v-30.91c.001-2.409-1.953-4.363-4.363-4.363z",
    fill: "url(#SVGID_33_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 424.806,
    cy: 119.091,
    fill: "url(#SVGID_34_)",
    r: 13.575
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m433.564 66.333c0-2.41 1.954-4.363 4.363-4.363h30.91c2.41 0 4.363 1.954 4.363 4.363 0 2.41-1.954 4.363-4.363 4.363h-30.91c-2.409.001-4.363-1.953-4.363-4.363z",
    fill: "url(#SVGID_35_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 477.564,
    cy: 66.333,
    fill: "url(#SVGID_36_)",
    r: 13.575
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m416.049 66.333c0-2.41-1.954-4.363-4.363-4.363h-30.91c-2.41 0-4.363 1.954-4.363 4.363 0 2.41 1.954 4.363 4.363 4.363h30.91c2.409.001 4.363-1.953 4.363-4.363z",
    fill: "url(#SVGID_37_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 372.048,
    cy: 66.333,
    fill: "url(#SVGID_38_)",
    r: 13.575
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m430.999 60.141c-1.704-1.704-1.704-4.467 0-6.171l21.857-21.857c1.704-1.704 4.467-1.704 6.171 0 1.704 1.704 1.704 4.467 0 6.171l-21.857 21.857c-1.704 1.704-4.467 1.704-6.171 0z",
    fill: "url(#SVGID_39_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462.112,
    cy: 29.028,
    fill: "url(#SVGID_40_)",
    r: 13.575
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m418.614 72.526c-1.704-1.704-4.467-1.704-6.171 0l-21.857 21.857c-1.704 1.704-1.704 4.467 0 6.171 1.704 1.704 4.467 1.704 6.171 0l21.857-21.857c1.704-1.704 1.704-4.467 0-6.171z",
    fill: "url(#SVGID_41_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.501,
    cy: 103.639,
    fill: "url(#SVGID_42_)",
    r: 13.575
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m430.999 72.526c1.704-1.704 4.467-1.704 6.171 0l21.857 21.857c1.704 1.704 1.704 4.467 0 6.171-1.704 1.704-4.467 1.704-6.171 0l-21.857-21.857c-1.704-1.704-1.704-4.467 0-6.171z",
    fill: "url(#SVGID_43_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 462.112,
    cy: 103.639,
    fill: "url(#SVGID_44_)",
    r: 13.575
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "m418.614 60.141c1.704-1.704 1.704-4.467 0-6.171l-21.857-21.857c-1.704-1.704-4.467-1.704-6.171 0-1.704 1.704-1.704 4.467 0 6.171l21.857 21.857c1.704 1.704 4.467 1.704 6.171 0z",
    fill: "url(#SVGID_45_)"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 387.501,
    cy: 29.028,
    fill: "url(#SVGID_46_)",
    r: 13.575
  }))), /*#__PURE__*/React.createElement("circle", {
    cx: 424.806,
    cy: 66.333,
    fill: "url(#SVGID_47_)",
    r: 33.072
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 471.64,
    cy: 152.908,
    fill: "url(#SVGID_48_)",
    r: 19.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 120.145,
    cy: 19.5,
    fill: "url(#SVGID_49_)",
    r: 19.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 460.389,
    cy: 197.158,
    fill: "url(#SVGID_50_)",
    r: 12.249
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 161,
    cy: 38,
    fill: "url(#SVGID_51_)",
    r: 12.249
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 478.89,
    cy: 377.268,
    fill: "url(#SVGID_52_)",
    r: 12.249
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.11,
    cy: 319.333,
    fill: "url(#SVGID_53_)",
    r: 12.249
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 31.11,
    cy: 448,
    fill: "url(#SVGID_54_)",
    r: 12.249
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.622,
    cy: 318,
    fill: "url(#SVGID_55_)",
    r: 7.518
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 483.622,
    cy: 466,
    fill: "url(#SVGID_56_)",
    r: 7.518
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 62.5,
    cy: 30.5,
    fill: "url(#SVGID_57_)",
    r: 12.249
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconStayHome);
export default __webpack_public_path__ + "static/media/icon-stay-home.cfc4f62013bba878f7648f2e8b0e24c4.svg";
export { ForwardRef as ReactComponent };